module.exports = __webpack_public_path__ + "static/img/news6.4d4a15f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/news6.jpg
// module id = 9J5u
// module chunks = 1